import IndexTable from './IndexTable';
import IndexTableRow from './IndexTableRow';

IndexTable.Row = IndexTableRow;

export {
  IndexTable
};
